export const twitter = {
  handle: "@bugoverdose_i_dont_do_twitter",
  site: "@bugoverdose",
  cardType: "summary_large_image",
};
